import { Routes } from '@angular/router';
import { AppShell } from './layout/app-shell';
import { authGuard } from './core/auth/auth.guard';

export const routes: Routes = [
  {
    path: '',
    component: AppShell,
    canActivate: [authGuard],
    children: [
      {
        path: '',
        loadComponent: () => import('./features/dashboard/dashboard').then((m) => m.Dashboard),
        title: 'menu.dashboard',
      },
      {
        path: 'hr',
        loadChildren: () => import('./features/hr/hr.routes'),
        title: 'menu.employees',
      },
      {
        path: 'samouczek',
        loadComponent: () => import('./features/samouczek/samouczek').then((m) => m.Samouczek),
        title: 'menu.tutorial',
      },
      {
        path: 'zgloszenia',
        loadComponent: () => import('./features/support/support').then((m) => m.Support),
        title: 'menu.support',
      },
    ],
  },
  { path: 'auth', loadChildren: () => import('./features/auth/auth.routes') },
  { path: '**', redirectTo: '' },
];
